<template>
  <div>
    <!-- 搜索区 -->
    <search-component @handleQueryData="handelSearch" @handleFilterData="handleFilter" />
    <add-btn v-hasPermi="['cont:newSaleContract:add']" @add="handleAddContract()" />
    <!-- 合同列表区 start -->
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="handleContract" v-if="list.length > 0">
      <total-component :totalValue="total" />
      <list-item @todetail="toContractDetails" :listData="list" />
    </van-list>
    <empty-component v-if="isEmpty" />
    <!-- 合同列表区 end -->

    <!--客户搜索-->
    <search-pop :show.sync="showFilterPop" @handlequery="handleFqueryFilter" />

    <!-- <dialog-cont :show='add_show' :contractType='6' :deptTreeOptions="deptTreeList"   @handleAddContractCancel='handleAddContractCancel' @beforeClose='addContractBeforeClose'></dialog-cont> -->
  </div>
</template>
<script>
import moment from 'moment'
import purchase from '@/api/cont/purchase'
import { getDicts } from '@/api/system/dict/data'
import { CascaderTreeSelect } from '@/api/admi/dept'
import SearchComponent from '@/components/common/Search'
import ListItem from './components/ListContractItem.vue'
import EmptyComponent from '@/components/common/Empty'
import TotalComponent from '@/components/common/Total'
import SearchPop from './components/SearchPop.vue'
import AddBtn from '@/components/common/AddBtn'
// import { Toast } from 'vant'
export default {
  components: {
    SearchComponent,
    EmptyComponent,
    TotalComponent,
    SearchPop,
    AddBtn,
    ListItem
  },
  filters: {
    timeFormat(val) {
      return moment(val).format('YYYY-MM-DD')
    }
  },
  data() {
    return {
      isEmpty: false,
      add_show: false,
      picker: {
        visible: false,
        title: '',
        columns: [],
        formKey: ''
      },
      loading: false,
      finished: false,
      noConLoading: false,
      noConFinished: false,
      failConLoading: false,
      failConFinished: false,
      otherConLoading: false,
      otherConFinished: false,
      showFilterPop: false,
      fileList: [],
      fileList1: [],
      fileList2: [],
      list: [],
      total: 0,
      noList: [],
      failList: [],
      otherList: [],
      type: 'add',
      show: false,
      searchParams: {
        visible: false,
        contractType: '6'
      },
      searchValue: '',
      custList: [],
      // 客户等级
      custLevelOptions: [],
      // 地区树选项
      areaOptions: [],
      // 行业树选项
      industryOptions: [],
      // 客户类型字典
      custTypeOptions: this.$store.state.dictOptions.crmCustType || [],
      // 提单状态
      boStatusOptions: this.$store.state.dictOptions.custBoStatus || [],
      // 释放类型
      releaseModeOptions: [],
      // 客户来源字典
      custSourceOptions: this.$store.state.dictOptions.custSource || [],
      // 投放类型列表
      launchTypeOptions: this.$store.state.dictOptions.custOrderLaunchType || [],
      // 产品类型列表
      businessTypeOptions: this.$store.state.dictOptions.contractBusinessType || [],
      // 合同状态
      contractStatusOptions: this.$store.state.dictOptions.contractStatus || [],
      // 合同类型
      contractTypeOptions: this.$store.state.dictOptions.contractType || [],
      // 支付方式
      payModeOptions: this.$store.state.dictOptions.payMode || [],
      // 合同附件类型
      contFileTypeOptions: this.$store.state.dictOptions.contFileType || [],

      options: [],
      // 部门tree
      deptTreeList: [],
      showStartCalendar: false,
      showEndCalendar: false,
      showSignCalendar: false,
      minDate: new Date(2010, 0, 1),
      minDateStart: new Date(2010, 0, 1),
      active: 0,
      // 列表
      activeName: 'list_contract',
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        contractStatus: 0,
        orderByColumn: 'createTime',
        isAsc: 'desc'
      }
    }
  },
  async created() {
    // 合同模板
    await getDicts('template_type').then(res => {
      this.options.templateTypeOptions = res.data
    })
    // 框架类型
    await getDicts('frame_type').then(res => {
      this.options.frameTypeOptions = res.data
    })
    // 垫款方式
    await getDicts('pay_type').then(res => {
      this.options.payTypeOptions = res.data
    })
    // 合同状态
    await getDicts('contract_status').then(res => {
      this.options.contractStatusOptions = res.data
    })
    // 框架类型
    await getDicts('cust_source').then(res => {
      this.options.custSourceOptions = res.data
    })
    await this.handleContract()
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      // 修改主体框架标题
      document.title = '起草合同——新增合同'

      // 获取部门信息
      await CascaderTreeSelect().then((response) => {
        this.deptTreeList = response.data
      })

      // 释放类型
      getDicts('release_mode').then((response) => {
        this.releaseModeOptions = response.data
      })
    },
    formatHandel(type, value) {
      const options = type + 'Options'
      if (value || value == 0) {
        return this.selectDictLabel(this.options[options], value)
      } else {
        return ''
      }
    },
    // 提单状态
    boStatusFormat2(boStatus) {
      return this.selectDictLabel(this.boStatusOptions, boStatus)
    },
    // 产品类型
    businessTypeFormat2(businessType) {
      return this.selectDictLabel(this.businessTypeOptions, businessType)
    },
    // 投放类型
    launchTypeFormat2(launchType) {
      return this.selectDictLabel(this.launchTypeOptions, launchType)
    },
    contractTypeFormat2(contractType) {
      return this.selectDictLabel(this.contractTypeOptions, contractType)
    },
    contractStatusFormat2(contractStatus) {
      return this.selectDictLabel(this.contractStatusOptions, contractStatus)
    },
    // 合同类型字典翻译
    contractTypeFormat(row, column) {
      return this.selectDictLabel(this.contractTypeOptions, row.contractType)
    },
    // 合同状态字典翻译
    contractStatusFormat(row, column) {
      return this.selectDictLabel(
        this.contractStatusOptions,
        row.contractStatus
      )
    },
    // 支付方式字典翻译
    payModeFormat2(payMode) {
      return this.selectDictLabel(this.payModeOptions, payMode)
    },
    payModeFormat(row, column) {
      return this.selectDictLabel(this.payModeOptions, row.payMode)
    },
    formatDate(date) {
      // 时间格式化 2019-09-08
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()
      return year + '-' + month + '-' + day
    },
    onStartCalendarConfirm(data) {
      this.form.startTime = this.formatDate(data)
      this.showStartCalendar = false
      this.minDateStart = data
    },
    onEndCalendarConfirm(data) {
      this.form.endTime = this.formatDate(data)
      this.showEndCalendar = false
    },
    onSignCalendarConfirm(data) {
      this.form.signTime = this.formatDate(data)
      this.showSignCalendar = false
    },
    // 搜索子组件传递过来的搜索关键字
    handelSearch(data) {
      this.resetQuery()
      this.queryParams.contractName = this.searchValue = data
      this.queryContractList()
    },
    // 过滤子组件传递过来的搜索对象
    handleFqueryFilter(data) {
      const query = this.queryParams
      this.queryParams = { ...query, ...data }
      this.queryContractList()
    },
    // 接收子组件的filter事件
    handleFilter() {
      this.showFilterPop = true
    },
    queryContractList() {
      this.list = []
      this.queryParams.pageNum = 1
      this.handleContract()
    },
    toContractDetails(item) {
      this.$router.push({
        path: '/project/purchase/detail',
        query: {
          id: item.contractId
        }
      })
    },
    handleAddContract() {
      // this.add_show = true;
      this.$router.push({
        path: '/project/purchase/add',
        type: 'add'
      })
    },
    async handleContract() {
      this.loading = true
      const res = await purchase.listSaleContract(this.queryParams)
      if (res.code === 200) {
        if (res.rows.length === 0) {
          this.isEmpty = true
        } else {
          this.isEmpty = false
        }
        this.list = this.list.concat(res.rows)
        this.total = res.total
        this.queryParams.pageNum += 1
        this.loading = false
        this.finished = this.list.length >= res.total
        this.showFilterPop = false
      }
    },
    resetQuery() {
      this.queryParams = {
        pageNum: 1,
        pageSize: 10,
        custOrderId: null,
        contractNum: null,
        contractName: null,
        custId: null,
        custName: null,
        contractSource: null,
        contractType: '',
        contractStatus: 0,
        payMode: null,
        hkStatus: null,
        verifyStatus: 0,
        contractMoney: null,
        startTime: null,
        endTime: null,
        custSignedUser: null,
        mySignedUser: null,
        signTime: null,
        contractFile: null,
        annexOne: null,
        annexTwo: null,
        content: null,
        readerCount: null,
        status: null,
        orderByColumn: 'createTime',
        isAsc: 'desc'
      }
    }
  }
}
</script>
<style lang="less" scoped>
.editClue /deep/.van-dialog__content {
  height: 80%;
}
</style>
